<template>
    <div class="c2cIndexList">
        <ul class="listWrap">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :offset="10"
                    finished-text="没有更多了"
                    @load="onLoad">
                <li v-for="(item,index) in listData" :key="index">
                    <div class="top">
                        <span>数量：{{item.remain}} USDT</span>
                        <p>￥{{item.price}}<span>/USDT</span></p>
                    </div>
                    <!-- <div class="center">
                         数量：{{item.remain}} USDT
                     </div>-->
                    <div class="bottom">
                        <div class="imgWrap">
                            <img :src="item.weixin ? wx_active : wx" alt="">
                            <img :src="item.alipay ? ali_active : ali" alt="">
                            <img :src="item.bank ? yl_active : yl" alt="">
                        </div>
                        <button v-if="type ==='buy'" style="background: #1FC26D" @click="buyEvent(item)">购买</button>
                        <button v-if="type ==='sell'" style="background: #FF4D30" @click="sellEvent(item)">出售</button>
                    </div>
                </li>
            </van-list>
        </ul>
        <!--弹框-->
        <van-dialog v-model="show" show-cancel-button
                    cancel-button-color="#999999"
                    confirmButtonColor="#1FC26D"
                    @confirm="confirmEvent">
            <div class="alertBox">
                <div class="top">
                    <div>{{type ==='buy' ? '购买':'出售'}} USDT</div>
                    <div>可用USDT：<span>{{this.myUsdt}}</span></div>
                </div>
                <div class="coinInfo">
                    <img src="../../../assets/img/user/usdt.png" alt=""/>
                    <div>
                        <span>价格：{{item.price}} RMB</span>
                        <span>剩余数量：{{item.remain}}</span>
                    </div>
                </div>
                <div class="inputBox">
                    <div>
                        <input type="text" placeholder="请输入数量" v-model="num">
                        <span>USDT</span>
                    </div>
                    <div>
                        <input type="text" placeholder="" disabled :value="num * item.price || ''">
                        <span>RMB</span>
                    </div>
                    <div>
                        <input type="password" placeholder="交易密码" v-model="paypassword">
                    </div>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    // 微信图片
    import wx from "@/assets/img/c2c/wx@3x.png"
    import wx_active from "@/assets/img/c2c/wx_active@3x.png"
    // 支付宝图片
    import ali from "@/assets/img/c2c/ali@3x.png"
    import ali_active from "@/assets/img/c2c/ali_active@3x.png"
    // 银联图片
    import yl from "@/assets/img/c2c/yl@3x.png"
    import yl_active from "@/assets/img/c2c/yl_active@3x.png"

    export default {
        name: "c2c-index-list",
        props: {
            type: {
                default: "buy"
            }
        },
        data() {
            return {
                wx,
                wx_active,
                ali,
                ali_active,
                yl,
                yl_active,
                show: false,
                page: 0,
                total: null,
                loading: false,
                finished: false,
                listData: [],
                item: {},
                myUsdt: "",
                num: "",
                paypassword: "",
            }
        },
        methods: {
            // 弹框确认事件
            confirmEvent() {
                let url = this.type === "buy" ? 'appapi/c2c/buy' : 'appapi/c2c/sell';
                let obj = {
                    adid: this.item.id,
                    num: this.num,
                    paypassword: this.paypassword,
                };
                this.ajax.post(url, obj).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        this.$router.push({path: "/c2cOrder", query: {id: res.data.data.id}});
                    }
                });
            },
            getListData() {
                this.page++;
                let obj = {
                    page: this.page,
                    coin: "usdt",
                    type: this.type === "buy" ? 2 : 1
                };
                this.ajax.post('appapi/c2c/lists', obj).then((res) => {
                    if (res.data.code === 1) {
                        this.myUsdt = parseFloat(res.data.data.usdt);
                        this.listData.push(...res.data.data.data.data);
                        this.total = res.data.data.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.listData.length >= this.total) {
                            console.log("加载完成");
                            this.finished = true;
                        }
                    }
                })
            },
            onLoad() {
                setTimeout(() => {
                    this.getListData();
                }, 500);
            },
            // 显示 购买/出售 弹框
            buyEvent(item) {
                this.ajax.post('appapi/c2c/releaseC2c', {coin: "usdt"}).then((res) => {
                    if (res.data.code === 1) {
                        let publishData = res.data.data;
                        if (publishData.weixin < 0 &&
                            publishData.alipay < 0 &&
                            publishData.bank < 0) {
                            this.$toast("请先绑定支付方式");
                            return
                        }
                        this.item = item;
                        this.show = true;
                    }
                });

            },
            sellEvent(item) {
                this.ajax.post('appapi/c2c/releaseC2c', {coin: "usdt"}).then((res) => {
                    if (res.data.code === 1) {
                        let publishData = res.data.data;
                        if (publishData.weixin < 0 &&
                            publishData.alipay < 0 &&
                            publishData.bank < 0) {
                            this.$toast("请先绑定支付方式");
                            return
                        }
                        this.item = item;
                        this.show = true;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .c2cIndexList {
        margin-top: 45px;
        padding: 0 35px 100px;

        .listWrap {
            li {
                box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.5);
                border-radius: 20px;
                padding: 40px 53px;
                margin-bottom: 25px;
                background: #fff;

                .top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 29px;

                    span {
                        font-size: 28px;
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                        line-height: 20px;
                    }

                    p {
                        font-size: 32px;
                        font-weight: bold;
                        color: rgba(22, 207, 122, 1);
                        line-height: 36px;

                        span {
                            font-size: 26px;
                            color: rgba(22, 207, 122, 1);
                        }
                    }
                }

                .center {
                    margin-bottom: 31px;
                    font-size: 28px;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    line-height: 20px;
                }

                .bottom {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .imgWrap {
                        display: flex;
                        align-items: center;

                        img {
                            &:nth-child(1) {
                                width: 41px;
                                margin-right: 24px;
                            }

                            &:nth-child(2) {
                                width: 40px;
                                margin-right: 33px;
                            }

                            &:nth-child(3) {
                                width: 63px;
                            }
                        }
                    }

                    button {
                        width: 153px;
                        height: 50px;
                        line-height: 50px;
                        font-size: 24px;
                        font-weight: bold;
                        color: #fff;
                        box-shadow: 0 1px 15px 0 rgba(131, 131, 131, 0.2);
                        border-radius: 25px;
                    }
                }
            }
        }

        .alertBox {
            padding: 39px 43px 45px;

            .top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 40px;

                div {
                    &:first-child {
                        font-size: 34px;
                        font-weight: bold;
                        color: rgba(64, 76, 91, 1);
                    }

                    &:last-child {
                        font-size: 28px;
                        font-weight: 500;
                        color: rgba(64, 76, 91, 1);
                    }

                    span {
                        color: #14B94E;
                    }
                }
            }

            .coinInfo {
                display: flex;
                align-items: center;
                height: 82px;
                margin-bottom: 40px;

                img {
                    width: 82px;
                    height: 82px;
                    margin-right: 26px;
                }

                div {
                    display: flex;
                    flex-direction: column;
                    padding: 8px 0 11px;

                    span {
                        margin-bottom: 13px;
                        font-size: 26px;
                        font-weight: 500;
                        color: rgba(116, 126, 137, 1);
                        line-height: 25px;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .inputBox {
                div {
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-bottom: 30px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    input {
                        width: 100%;
                        height: 78px;
                        padding-left: 30px;
                        background: rgba(249, 249, 249, 1);
                        border-radius: 10px;
                        font-size: 24px;
                        font-weight: 500;
                    }

                    span {
                        display: flex;
                        align-items: center;
                        height: 100%;
                        position: absolute;
                        right: 30px;
                    }
                }
            }
        }
    }
</style>
